// series
export const TMDB_START = 'TMDB_START';
export const TMDB_FAIL = 'TMDB_FAIL';
export const TMDB_FIND_SERIES_SUCCES = 'TMDB_FIND_SERIES_SUCCES';
export const FETCH_EPISODE_DETAILSSUCCES = 'FETCH_EPISODE_DETAILSSUCCES';
export const FETCH_SERIES_DETAILSSUCCES = 'FETCH_SERIES_DETAILSSUCCES';

// auth
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';


// myTrackedSeries FireBase
export const FIREBASE_START = 'FIREBASE_START';
export const FIREBASE_SAVE = 'FIREBASE_SAVE';
export const FIREBASE_FAIL = 'FIREBASE_FAIL';
export const FIREBASE_SAVE_OPTIONS_SUCCES = 'FIREBASE_SAVE_OPTIONS_SUCCES';
export const FIREBASE_SAVE_SERIES_SUCCES = 'FIREBASE_SAVE_SERIES_SUCCES';
export const FIREBASE_FETCH_DATA_SUCCES = 'FIREBASE_FETCH_DATA_SUCCES';
export const FIREBASE_DELETE_SERIES_SUCCES = 'FIREBASE_DELETE_SERIES_SUCCES';
export const CLEAR_MY_DATA = 'CLEAR_MY_DATA';